import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

// Import Background Image
import Background from '../assets/images/service-icon-bg.png'
import Icon1 from '../assets/images/services-icon/devops.png'
import Icon2 from '../assets/images/services-icon/software-testing.png'
import Icon3 from '../assets/images/services-icon/gear.png'
import { Link } from 'react-router-dom'

export default class Services extends Component {
	render() {
		return (
			<React.Fragment>
				<section className='section bg-light' id='services'>
					<Container>
						<Row className='justify-content-center'>
							<Col lg={7}>
								<div className='text-center mb-5'>
									<h2 className=''>Our Services</h2>
									<p className='text-muted'>
										From seamless software delivery that ensures high-quality,
										scalable applications, to testing services that guarantee
										performance and reliability, we cover every step of your
										software journey. Our DevOps/SysOps solutions optimize your
										infrastructure and streamline operations, empowering your
										business to innovate faster and operate more efficiently.
									</p>
								</div>
							</Col>
						</Row>
						<Row>
							<Col lg={4}>
								<div className='card service-box text-center p-4'>
									<div
										className='service-icon-bg mx-auto avatar-xxl p-4'
										style={{ backgroundImage: `url(${Background})` }}
									>
										<div className='service-box-icon justify-content-center'>
											<img src={Icon1} alt='' className='img-fluid d-block' />
										</div>
									</div>
									<h4 className='service-title mt-4 mb-3 f-18'>
										Software Delivery
									</h4>
									<p className='service-subtitle mb-4 f-15'>
										We help you build and deploy high-quality, scalable software
										solutions that meet your business needs. From ideation to
										production, we ensure seamless development, timely delivery,
										and continuous improvement, empowering your business to stay
										competitive in a fast-evolving digital landscape.
									</p>
									{/* <Link to='#' className='read-more'>
										More<span className='right-icon ml-2'>&#8594;</span>
									</Link> */}
								</div>
							</Col>
							<Col lg={4}>
								<div className='card service-box text-center p-4'>
									<div
										className='service-icon-bg mx-auto avatar-xxl p-4'
										style={{ backgroundImage: `url(${Background})` }}
									>
										<div className='service-box-icon justify-content-center'>
											<img src={Icon2} alt='' className='img-fluid d-block' />
										</div>
									</div>
									<h4 className='service-title mt-4 mb-3 f-18'>
										Testing Services
									</h4>
									<p className='service-subtitle mb-4 f-15'>
										Our rigorous testing services ensure that your software
										performs as expected, remains bug-free, and delivers an
										exceptional user experience. We specialize in automated and
										manual testing, performance testing, and security
										assessments to help you release with confidence.
									</p>
									{/* <Link to='#' className='read-more'>
										More<span className='right-icon ml-2'>&#8594;</span>
									</Link> */}
								</div>
							</Col>
							<Col lg={4}>
								<div className='card service-box text-center p-4'>
									<div
										className='service-icon-bg mx-auto avatar-xxl p-4'
										style={{ backgroundImage: `url(${Background})` }}
									>
										<div className='service-box-icon justify-content-center'>
											<img src={Icon3} alt='' className='img-fluid d-block' />
										</div>
									</div>
									<h4 className='service-title mt-4 mb-3 f-18'>
										DevOps/SysOps
									</h4>
									<p className='service-subtitle mb-4 f-15'>
										Tapio's DevOps and SysOps services streamline your IT
										infrastructure, enhance collaboration between development
										and operations teams, and enable faster, more reliable
										software delivery. We automate processes, improve system
										scalability, and ensure continuous monitoring for optimal
										performance and uptime.
									</p>
									{/* <Link to='#' className='read-more'>
										More<span className='right-icon ml-2'>&#8594;</span>
									</Link> */}
								</div>
							</Col>
							<Col lg={12}>
								<div className='card service-box text-center p-4'>
									<div
										className='service-icon-bg mx-auto avatar-xxl p-4'
										style={{ backgroundImage: `url(${Background})` }}
									>
										<div className='service-box-icon justify-content-center'>
											<img src={Icon3} alt='' className='img-fluid d-block' />
										</div>
									</div>
									<h4 className='service-title mt-4 mb-3 f-18'>
										WCAG 2.1 Compliance Audits
									</h4>
									<p className='service-subtitle mb-4 f-15'>
										We ensure your website or platform meets WCAG 2.1
										accessibility standards. Our team conducts thorough audits
										to identify and fix barriers for users with disabilities,
										enhancing accessibility and improving user experience for
										everyone.
									</p>
									{/* <Link to='#' className='read-more'>
										More<span className='right-icon ml-2'>&#8594;</span>
									</Link> */}
								</div>
							</Col>
						</Row>
					</Container>
				</section>
			</React.Fragment>
		)
	}
}
